export function getSources() {
    var sources = ['EmailAttachment', 'OneDrive', 'Sharepoint'];
    // TODO: move to a shared place if Feed api also need this sources param.
    // TODO: PWA local files recommendation
    // if (capabilities.isPwaInUwp) {
    //     sources.push('LocalFile');
    // }
    return sources;
}
//# sourceMappingURL=getSources.js.map